export default __webpack_public_path__ + "static/hello-badge-cc201cbd7faf742329aed1e87aecdac5.png";